import { render, staticRenderFns } from "./ProductLight530.vue?vue&type=template&id=1b9a832c&scoped=true"
import script from "./ProductLight530.vue?vue&type=script&lang=js"
export * from "./ProductLight530.vue?vue&type=script&lang=js"
import style0 from "./ProductLight530.vue?vue&type=style&index=0&id=1b9a832c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a832c",
  null
  
)

export default component.exports